// ##### 25-02-21 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import LangSelectionTool from '../../../../Library/Localization/LangSelectionTool/LangSelectionTool';
import CurrencySelectionTool from '../../CurrencySelectionTool/CurrencySelectionTool';

// ##### Komarov 2025-07-14
const CurrencyAndLanguageSelectionTools = ({ className }) => {
  return (
    <div
      className={className}
      data-component="CurrencyAndLanguageSelectionTools"
    >
      {/* ##### 25-02-21 Komarov */}
      <CurrencySelectionTool />
      <LangSelectionTool />
    </div>
  );
};

export default CurrencyAndLanguageSelectionTools;
